import { Calendar } from '@/helpers/classes/calendar';
import moment from 'moment';

export const calendarMixins = {
  methods: {
    async getClassCalendar(infrastructure, removeWeekdaysValue = false) {
      const calendar = new Calendar();
      await calendar.initialize(infrastructure, removeWeekdaysValue);
      return calendar;
    },
    dateToStringFormat(date, format = 'YYYY-MM-DD') {
      return date ? moment(date).format(format) : null;
    },
  },
};
